module.exports = __webpack_public_path__ + "img/internet-pic.94ed7a97.png";